import { Clock, XClose } from '@untitledui/icons'

import type { HistoryEntry } from '@components/productFinder/useHistory'

interface HistoryProps {
  history: HistoryEntry[]
  onEntrySelect: (term: string) => void
  onEntryRemove: (term: string) => void
}

function History({ history, onEntrySelect, onEntryRemove }: HistoryProps) {
  return (
    <ul className="flex flex-col gap-4 divide-y divide-border-primary" data-testid="search-history">
      {history.map((entry) => (
        <li key={entry.term} className="flex items-center justify-between p-4" data-testid="search-history-item">
          <button className='flex cursor-pointer gap-2' onClick={() => onEntrySelect(entry.term)}>
            <Clock/>
            {entry.term}
          </button>

          <button>
            <XClose
              onClick={() => onEntryRemove(entry.term)}
              className='cursor-pointer'
            />
          </button>
        </li>
      ))}
    </ul>
  )
}

export default History